<template>
  <div class="news">
    <picture>
      <source
        media="(max-width: 767px)"
        srcset="~@/assets/images/news-mobile.png 767w"
      />
      <img class="news-banner" src="~@/assets/images/news.jpg" />
    </picture>
    <Title />
    <div>
      <div v-if="showDetail">
        <NewsItemDetail :newsData="currentDetail" />
      </div>
      <div v-else>
        <div v-for="item in displayList" :key="item.id">
          <NewsItem :newsData="item" :page="page" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NewsList from 'Assets/mockData/NewsList.json';
import ActivityList from 'Assets/mockData/ActivityList.json';
import NewsItem from 'Pages/NewsModule/NewsViewItem.vue';
import NewsItemDetail from 'Pages/NewsModule/NewsViewItemDetail.vue';
import Title from 'Pages/MainModule/Title.vue';

export default {
  name: 'News',
  components: {
    NewsItem,
    NewsItemDetail,
    Title,
  },
  data() {
    return {
      page: this.$route.query.page,
      id: this.$route.query.id || '',
      newsList: NewsList,
      activityList: ActivityList,
    };
  },
  watch: {
    $route() {
      this.page = this.$route.query.page;
      this.id = this.$route.query.id || '';
    },
  },
  computed: {
    displayList: function() {
      if (this.page === '2') {
        return this.activityList;
      } else {
        return this.newsList;
      }
    },
    showDetail: function() {
      return this.id !== '';
    },
    currentDetail: function() {
      return this.displayList.filter((item) => {
        return item.id === this.id;
      })[0];
    },
  },
};
</script>

<style scoped>
.news {
  font-size: 72px;
  font-weight: normal;
}
.news > div {
  margin: 20px 20% 0 20%;
}
.news-banner {
  width: 100%;
  vertical-align: top;
}
@media (max-width: 767px) {
  .news-banner {
    margin-top: 10px;
    /* height: 55vw; */
  }

  .news > div {
    margin-left: 20px;
    margin-right: 20px;
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  .news > div {
    margin: 20px 10% 0 10%;
  }
}
</style>
